import {
  alerter,
} from '@codev/helix-react';
import React from 'react';
import PropTypes from 'prop-types';
import Frame from '../Frame.jsx';
import LogoPanel from '../LogoPanel.jsx';
import PanelDivider from '../PanelDivider.jsx';
import handleNetworkError from '../utilities/handleNetworkError.js';
import Retrier from '../utilities/Retrier.js';
import api from './api.js';
import EmailMessage from './EmailMessage.jsx';
import UsernameForm from './UsernameForm.jsx';

class ForgotPasswordView extends React.Component {
  constructor(props) {
    super(props);

    this.retrier = new Retrier({
      mode: "alerter",
    });

    this.state = {
      username: '',
      verificationSent: false,
    };
  }

  handleSubmit = async (captchaToken) => {
    await this.retrier.try({
      retryMessage: 'We were unable to submit a password reset request.  Please try again.',
      action: async () => {
        let {
          antiforgeryConfig,
        } = this.props;
        let {
          username,
        } = this.state;

        alerter.dismiss();

        await handleNetworkError(async () => {
          await api.startForgotPassword(username, antiforgeryConfig.value, captchaToken);
        });

        this.setState({
          verificationSent: true,
        });
      },
    });
  }

  render() {
    let {
      logoUrl,
      captchaSiteKey
    } = this.props;
    let {
      username,
      verificationSent,
    } = this.state;

    return (
      <Frame
        title="Control Panel Login"
        style={logoUrl ? null : {minWidth: '390px'}}
      >
        {
          logoUrl &&
          <LogoPanel
            logoUrl={logoUrl}
          />
        }
        {
          logoUrl &&
          <PanelDivider />
        }

        {
          !verificationSent &&
          <UsernameForm
            onChange={x => this.setState({username: x.target.value})}
            onSubmit={this.handleSubmit}
            username={username}
            captchaSiteKey={captchaSiteKey}
          />
        }
        {
          verificationSent &&
          <EmailMessage
            username={username}
          />
        }
      </Frame>
    );
  }
}

ForgotPasswordView.propTypes = {
  antiforgeryConfig: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  logoUrl: PropTypes.string,
  captchaSiteKey: PropTypes.string
};
export default ForgotPasswordView;
